import { render, staticRenderFns } from "./UnassignedServiceRequest.vue?vue&type=template&id=413d82c6&scoped=true&"
import script from "./UnassignedServiceRequest.vue?vue&type=script&lang=js&"
export * from "./UnassignedServiceRequest.vue?vue&type=script&lang=js&"
import style0 from "./UnassignedServiceRequest.vue?vue&type=style&index=0&id=413d82c6&prod&lang=scss&scoped=true&"
import style1 from "./UnassignedServiceRequest.vue?vue&type=style&index=1&id=413d82c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413d82c6",
  null
  
)

export default component.exports